import React, { useEffect, useRef } from 'react';
import { FiCheck, FiPlusCircle, FiLogOut } from 'react-icons/fi';

const AccountDropdown = ({ accounts, activeAccountId, onSwitchAccount, onAddAccount, onDisconnect, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div className="ec-account-dropdown" ref={ref}>
      <div className="ec-dropdown-label">Connected Accounts</div>

      {accounts.map((account) => {
        const initial = account.email ? account.email[0].toUpperCase() : '?';
        const isActive = account.id === activeAccountId;

        return (
          <div
            key={account.id}
            className={`ec-dropdown-account${isActive ? ' active' : ''}`}
            onClick={() => !isActive && onSwitchAccount(account.id)}
            style={{ cursor: isActive ? 'default' : 'pointer' }}
          >
            <div className="ec-dropdown-avatar">{initial}</div>
            <div className="ec-dropdown-info">
              <div className="ec-dropdown-email">{account.email}</div>
              <div className="ec-dropdown-via">via {account.label}</div>
            </div>
            <div className="ec-dropdown-account-actions">
              {isActive && <FiCheck className="ec-dropdown-check" />}
              <button
                className="ec-dropdown-disconnect-icon"
                title={`Disconnect ${account.email}`}
                onClick={(e) => { e.stopPropagation(); onDisconnect(account.id); }}
              >
                <FiLogOut size={13} />
              </button>
            </div>
          </div>
        );
      })}

      <div className="ec-dropdown-hr" />

      <button className="ec-dropdown-action add" onClick={onAddAccount}>
        <FiPlusCircle /> Add Another Account
      </button>
    </div>
  );
};

export default AccountDropdown;
